import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {H2hWidgetConfig} from "./h2h-widget.config";
import {H2hWidgetStore} from "./h2h-widget.store";
import {FullGameResponseDomainService} from "../../domain/full-game/services/full-game-response.domain-service";
import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {H2hWidgetHandlers} from "./handlers/h2h-widget.handlers";

export class H2hWidgetController extends ModuleController {
  static injectables = [...BaseManagedService.injectables,  H2hWidgetConfig, H2hWidgetStore, H2hWidgetHandlers, FullGameResponseDomainService];
}